import React, { Component } from 'react'
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';

export class GridReorderEditModal extends Component<any, any>{
    render() {
        const headerActions = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'headerActions');
        return (
            <>
                <section role="dialog" className="slds-modal slds-fade-in-open slds-modal_small">
                    <div className="slds-modal__container">
                        <header className="slds-modal__header">
                            <h2 className="slds-text-heading_medium slds-hyphenate">Reorder Header Actions</h2>
                            <p></p>
                        </header>
                        <div className="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
                            <div className="slds-grid slds-wrap full-width">
                                {
                                    headerActions.length ? headerActions.map((recordType: any, index: number) => {
                                        return <div className="slds-grid slds-wrap" key={`${recordType.name}${index}`}>
                                            <div className="slds-m-bottom_x-small slds-m-right_x-small" role="presentation" draggable="true" onDragStart={(e) => this.handleDragStart(e, recordType)} onDrop={(e) => this.handleDrop(e, recordType)} onDragOver={this.handleDragOver}>
                                                <span className="slds-badge slds-badge_lightest">New {recordType.name}</span>
                                            </div>
                                        </div>
                                    }) : <div className="slds-grid slds-wrap">
                                            <p>Please configure header actions</p>
                                        </div>
                                }
                            </div>
                        </div>
                        <footer className="slds-modal__footer">
                            <button className="slds-button slds-button_neutral" onClick={() => this.props.toggleModalVisibility()}>Close</button>
                        </footer>
                    </div>
                </section>
                <div className="slds-backdrop slds-backdrop_open"></div>
            </>
        );
    }

    private handleDragStart = (e: any, data: any) => {
        let fromField = JSON.stringify(data);
        e.dataTransfer.setData("dragContent", fromField);
    };

    private handleDragOver = (event: any) => {
        event.preventDefault();
        return false;
    };

    private handleDrop = (event: any, field: any) => {
        event.preventDefault();
        let fromField = JSON.parse(event.dataTransfer.getData("dragContent"));
        this.swapBoxes(fromField, field);
        return false;
    };

    private move = (objArray: any, from: any, to: any) => {
        const item = objArray.splice(from, 1)[0];
        objArray.splice(to, 0, item);
        return objArray;
    };

    private swapBoxes = (fromField: any, toField: any) => {
        const fieldsToDisplay = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'headerActions');
        let formFieldIndex = 0;
        let toFieldIndex = 0;

        for (let i = 0; i < fieldsToDisplay.length; i++) {
            if (JSON.stringify(fieldsToDisplay[i]) === JSON.stringify(fromField)) {
                formFieldIndex = i;
            }
            if (JSON.stringify(fieldsToDisplay[i]) === JSON.stringify(toField)) {
                toFieldIndex = i;
            }
        }
        const filteredList = this.move(fieldsToDisplay, formFieldIndex, toFieldIndex);
        const headerActionTypes = [...CQMasterDataStore.GridObject.headerActionTypes];
        const headerActionsTypeArray = this.move([...headerActionTypes], formFieldIndex, toFieldIndex);
        this.props.updateHeaderActionType(headerActionsTypeArray);
        let headerActions: any = [];
        filteredList.length > 0 && filteredList.map((filteredItem: any) => {
            headerActions.push(filteredItem);
        });
        if (headerActions.length > 0) {
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'headerActions', headerActions);
        }
    };

}

export const GridLevelEditModal = observer(GridReorderEditModal);